import { createRouter, createWebHistory } from 'vue-router'
import Home from './pages/Home.vue'
import Download from './pages/Download.vue'
import Register from './pages/Register.vue'
import Contact from './pages/Contact.vue'
import Privacy from './pages/Privacy.vue'
import Pricing from './pages/Pricing.vue'
import Terms from './pages/Terms.vue'
import Help from './pages/Help.vue'

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/download', name: 'Download', component: Download },
  { path: '/register', name: 'Register', component: Register },
  { path: '/contact', name: 'Contact', component: Contact },
  { path: '/privacy', name: 'Privacy', component: Privacy },
  { path: '/pricing', name: 'Pricing', component: Pricing },
  { path: '/terms', name: 'Terms', component: Terms },
  { path: '/help', name: 'Help', component: Help },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router